<template>
  <div id="app">
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      bg_images: [require('./assets/bg_banner.jpeg')],
      cb_images: [require('./assets/logo_jt.png'),require('./assets/logo_jt.png'),require('./assets/logo_jt.png')],
      headerFixed:true,
      //banners: [ '/1.jpg', '/2.jpg', '/3.jpg' ],
      bannert:'/bg_banner.jpeg',
      height:"400px",
      cb_height:"400px",
      cb_carousel_height:"300px",
      horizontal:false,
      vertical:true,
      menuDisplay:'none',
      activeIndex:"1",
    }
  },
  methods: {
    onResize(){
      var width = document.documentElement.clientWidth;
      console.log(width);
      this.setCarouselHeight(width)
      this.setHeaderLayout(width)
    },
    setHeaderLayout(width){
      var cb_c_h = "340px";
      if (width <=1200) {
        this.vertical=true;
        this.horizontal=false;

      } else {
        this.horizontal=true;
        this.vertical=false;
      }

      if (width >= 1320) {
        this.cb_carousel_height="380px";
      } else if (width <1320) {
        this.cb_carousel_height="340px";
      }
    },
    setCarouselHeight(width){
      this.height = (width / 3.4).toString()+"px";
      this.cb_height = (width / 3).toString()+"px";
      // this.cb_carousel_height = (width /3)* (3/4).toString() + "px";
    },
    handleOpen(index, path){
      console.log(index, path)
    },

    handleClose(index, path){
      console.log(index, path)
    },
    handlerClick(){
      console.log("wft")
    }
  },
  mounted(){
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }
}
</script>

<style>
#app {
  position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    left: 0px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;
  color: #2c3e50;
  margin-top: 0px;*/
}

@font-face {
    font-family: "wryh";
    src: url("./assets/wryh.ttf") format("fft"); 
}

/* 头部导航 */
header{z-index: 1000;transition: all 0.5s ease;   background-color: #fff;  }
header.header-fixed{position: fixed;top: 0;left: 0;right: 0;}
header .el-menu-demo{padding-left: 300px!important;}
.carousel-img {
  width: 100%;
  height: 100%;
}
.main {
  margin-top: 60px;
}
.content-top p{
    text-align: center;
}
.content-cooper {
  background-color: #F4F5F6;
  /*margin-top: 40px;*/
  padding-bottom: 30px;
}
.content-cooper p{
  text-align: center;
  margin-top: 0px;
}

.title_img{
  text-align: center;
}

/*.media-div {
  border: 1px solid #83C0FB;
}*/
/*.content-top li {
  margin:7px;
 padding:5px;
 float:left;
 width:150px;
 height:190px;
 display: block;
 list-style:none;
}*/
#list {
 padding:0px;
 margin-left: 9%;
 margin-right: 2%;
 padding-top: 15px;
}
#list li{float:left;width:29%;height: auto;padding:6px;list-style:none;}
#list li .pic{display:block;width:auto;margin:0 auto;}
#list li .pic img{width:100%;height:100%;}

.footer {
  background-color: #252425;
  height: 200px;
  margin-top: 0px;
}
.footer p{
  color: white;
  font-size: 12px;
}
.footer_one {
  /*padding-top: 50px;*/
  float: right;
  padding-top: 43px
}
.footer_two{
  padding-top: 43px;
}
.footer_three{
  padding-top: 43px;
}
.copyright {
  background-color: #212121;
  text-align: center;
}
.copyright p{
  color: #888686;
  margin-top: 0px;
}
.carousel-img { max-width: 100%;width: 100%;-ms-interpolation-mode: bicubic;}

.vertical-style {
    width: 80px;
    float: right;
    padding-right: 0px;
}
/*.vertical-style .el-menu{
  right: 0px;
}*/
/*.vertical-style li{
  text-align: left;
}*/
.el-icon-arrow-down {
  display: none!important;
}
.el-submenu__title {
  border-bottom: 0px!important;
}
@media screen and (max-width: 600px) {
  #list {
     padding:0px;
     margin-left: 2px;
     margin-right: 0px;
     padding-top: 15px;
    }
  #list li {
    display: inline;
    float: left;
    width: 29.9%;
  }
}

.cb_list ul{
    width: 50%;
    text-decoration: none;
    list-style-type: none;
    margin: 0;
    border: 0;
    padding: 0;
    font-style: normal;
    color: #323232;
    box-sizing: border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box; /* Safari */
}

.cb_list img {
  width:100%;
  height:100%;
}
.cb_list>li{
    float: left;
    width: 23%;
    text-align: center;
    /*border: 1px solid #ccc;*/
    /*height: 50%;*/
    /*padding-top: 10%;*/
    margin-left: 1%;
    margin-top: 1%;
    position: relative;
    list-style:none;
}
.cb_list>li>div{
    height: auto;
    /*position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #09BE07;*/
}
.cb_list>li>div>span{
    display: inline-block;
    margin-top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}

/*.content-cb {
  background: url(./assets/bg_cb.png) no-repeat 0px -1px;
  min-height: 300px;
  background-color: #F4F5F6;
}
.content-cb p{
  text-align: center;
}


.content-cb img {
  max-width:100%;
}*/

@media screen and (min-width: 1400px) {
    .cb-carousel .el-carousel__container{
        height: 380px;
    }
}
@media screen and (min-width: 1349px) and (max-width: 1399px) {
    .cb-carousel .el-carousel__container{
        height: 350px;
    }
}
@media screen and (max-width: 1348px) and (min-width: 1000px) {
/*  .cb-img-box {
      padding-top: 4%;
    }*/
    .cb-carousel .el-carousel__container{
        height: 350px;
    }
}

@media screen and (max-width: 500px) and (min-width: 0px) {
    .content-cb {
      height: 250px
    }
    .cb-carousel .el-carousel__container{
        height: 170px;
    }
    .cb-img-box {
      padding-top: 4%;
    }
}

/*@media screen and (max-width: 1000px) and (min-width: 801px) {
    .content-cb {
      height: 300px
    }
    .cb-carousel .el-carousel__container{
        height: 200px;
    }
    
}
*/</style>



// WEBPACK FOOTER //
// src/App.vue